<template>
  <v-card elevation="1" rounded="lg" class="pa-3 d-flex align-center justify-space-between flex-wrap gap-2">
    <span class="wc-body-2 text-disabled">
      Mostrando {{ currentItems }} de {{ totalDocs }} submiembros
    </span>
    <div class="d-flex align-center">
      <v-btn
        icon
        small
        elevation="0"
        :disabled="page <= 1"
        class="mr-1"
        @click="goTo(page - 1)"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        v-for="p in visiblePages"
        :key="p"
        small
        elevation="0"
        :min-width="40"
        :width="40"
        :height="40"
        rounded
        class="mx-1"
        :class="p === page ? 'page-btn-active' : 'page-btn-inactive'"
        :color="p === page ? color.primaryVariant : 'transparent'"
        :outlined="p !== page"
        @click="goTo(p)"
      >
        <span
          :class="p === page ? 'white--text' : 'text-primary-variant'"
          class="font-weight-bold"
        >{{ p }}</span>
      </v-btn>
      <v-btn
        icon
        small
        elevation="0"
        :disabled="page >= length"
        class="ml-1"
        @click="goTo(page + 1)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { colors } from '@/constants/colors.js';

export default {
  name: 'MemberPagination',
  props: {
    page: {
      type: Number,
      default: 1,
    },
    length: {
      type: Number,
      default: 1,
    },
    totalDocs: {
      type: Number,
      default: 0,
    },
    currentItems: {
      type: Number,
      default: 0,
    },
    maxVisible: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      color: colors,
    };
  },
  computed: {
    visiblePages() {
      const total = this.length || 1;
      const max = this.maxVisible;
      if (total <= max) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      let start = Math.max(1, this.page - Math.floor(max / 2));
      let end = start + max - 1;
      if (end > total) {
        end = total;
        start = end - max + 1;
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  methods: {
    goTo(p) {
      if (p < 1 || p > (this.length || 1) || p === this.page) return;
      this.$emit('input', p);
    },
  },
};
</script>

<style scoped>
.page-btn-active {
  opacity: 1;
}
.page-btn-inactive {
  background-color: #ffffff;
}
.v-btn[disabled] {
  opacity: 0.4;
}
</style>
